import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/marketing/src/components/contentful/activityCatalog/activitiesHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/marketing/src/components/contentful/activityCatalog/activityCatalog.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/marketing/src/config/metadata/favicons/csforall.ico");
;
import(/* webpackMode: "eager" */ "/app/apps/marketing/src/config/metadata/favicons/favicon-codeai.ico");
;
import(/* webpackMode: "eager" */ "/app/apps/marketing/src/config/metadata/favicons/favicon-codeai.svg");
;
import(/* webpackMode: "eager" */ "/app/apps/marketing/src/config/metadata/favicons/hourofcode.ico");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/marketing/src/modules/activityCatalog/hourOfAi/crossLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExperienceRoot"] */ "/app/node_modules/@contentful/experiences-sdk-react/dist/ExperienceRoot.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@contentful/experiences-sdk-react/dist/hooks/useDetectCanvasMode.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@contentful/experiences-sdk-react/dist/hooks/useFetchByBase.js");
